module.exports = __webpack_public_path__ + "static/media/tips.410919ba.png";